module.exports = __webpack_public_path__ + "fonts/Inter-200-greek11.8c7f6ae.woff2";